import { useEpcProjectDetail } from '../EpcProjectDetailContext';
import EpcTeamWorkspace from '../team/EpcTeamWorkspace';
import type { EpcScheduleTaskRow } from '../../types/scheduleTask';

/**
 * Team & hierarchy: users from directory, roles per backend rules, departments with optional focus tags.
 */
export default function EpcProjectTeamTab() {
  const { id: projectId, canUpdate, snapshot, project } = useEpcProjectDetail();
  if (!projectId) return null;
  const scheduleTasks = (snapshot?.tasks as EpcScheduleTaskRow[] | undefined) ?? [];
  return (
    <EpcTeamWorkspace
      projectId={projectId}
      canUpdate={canUpdate}
      scheduleTasks={scheduleTasks}
      projectName={project?.name}
    />
  );
}
